import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

import { getErrorPages, State } from '../../reducers/index';
import { PushErrorPageAction } from '../../actions/error';
import { AnalyticsService } from '../../core/analytics';

@Component({
  selector: 'error-message',
  styleUrls: ['./error-message.component.scss'],
  template: `
    <div class="error-message"
      fxFlex
      fxLayout="column"
      fxLayoutAlign="space-around center">
      <img class="error-message__icon" src="../../../assets/img/sad-bag.jpg" alt="Error Icon" />
      <div class="error-message__tagline">We encountered an error.</div>
      @if (displayDetails) {
        <div
          class="error-message__error"
        [attr.data-testid]="page + 'error-message'">{{error}}</div>
      }
    </div>
    `,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})

export class ErrorMessageComponent implements OnInit {
  @Input() public error: string;
  @Input() public page: string;
  /** When false, the icon and tagline stay and the raw error text is not shown. */
  @Input() public displayDetails = true;

  public errorPages$: Observable<any>;

  constructor(private store: Store<State>, private analytics: AnalyticsService) {
    this.errorPages$ = this.store.select(getErrorPages);
  }

  public ngOnInit() {
    if (typeof this.error !== 'string') {
      this.error = 'Unknown error';
    }
    this.errorPages$.pipe(take(1)).subscribe((errorPages) => {
      // Make sure that the error is only sent once per user session
      if (errorPages.indexOf(this.page) < 0) {
        this.analytics.sendEvent(
          `${this.page} error`,
          { 'Error Message': this.error }
        );
        this.store.dispatch(new PushErrorPageAction(this.page));
      }
    });
  }
}
